import { AxiosResponse } from "axios";
import ApiResponse from "../Models/ApiResponse";
import api from "../Interceptors/Interceptor";


export class ErrorService {

    public async sendErrorMail(data: Record<string, unknown>): Promise<AxiosResponse<ApiResponse<any[]>>> {
        try {
            let response = await api.post(`v1/auth/error-mail`, data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }

    public async throwError(): Promise<AxiosResponse<ApiResponse<any[]>>> {
        let response = await api.get(`v1/auth/throw-error`);
        return response;
    }

    public async fetchStackTrace(): Promise<AxiosResponse<ApiResponse<any[]>>> {
        let response = await api.get(`v1/auth/stack-trace`);
        return response;
    }
}
